import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawerState: false,

    deliveryZipcode: '',
    authRedirect   : '/',
    authBehavior   : 'default',
    orderBehavior  : 'default',
    error          : null,
    success        : null,
    delays         : [],

    // authentication
    auth: {
      token: null,
      user : null,
    },

    // Order
    currentStep: null,
    order      : {
      complete         : false,
      shouldRestore    : false,
      continueAfterAuth: false,
      loaded           : false,
      list             : [],
      current          : null,
      clientSecret     : null,
      errors           : null,
      details          : null,
      menu             : null,
      menuEdited       : false,
      detailsEdited    : false
    },

    // Sub Order
    subOrder: {
      current  : null,
      character: null,
      event    : null,
    },

    // Order details
    orderDetails: {
      details: null,
      valid  : false,
      touched: false,
      errors : {}
    },

    // Order menu
    menu: {
      menu        : null,
      selectedMenu: null,
      created     : false,
      loaded      : false,
      valid       : false,
      touched     : false,
      errors      : {}
    },

    // Order Categories
    orderCategories: {
      categories : [],
      loaded     : false,
      current    : null,
      edit       : false,
      allSelected: false,
      list       : [],
    },

    //Line Items
    orderlineItems: {
      lineItems  : [],
      loaded     : false,
      current    : null,
      edit       : false,
      allSelected: false,
    },

    // Order messages
    orderMessages: {
      loaded : false,
      list   : [],
      current: null,
      created: false,
      trigger: []
    },

    // Message builder
    messageBuilder: {
      open   : false,
      edit   : false,
      message: null
    },

    // Order characters
    orderCharacters: {
      loaded  : false,
      list    : [],
      selected: [],
      current : null,
      edit    : false,
      edited  : false,
    },

    // Order Attendees
    orderAttendees: {
      loaded     : false,
      complete   : false,
      CSVuploaded: false,
      edited     : false,
      list       : [],
      valid      : false,
      errors     : {},
      touched    : false,
      created    : false,
    },

    // Default characters
    defaultCharacters: {
      loaded: false,
      list  : []
    },

    selectedMenu     : [],
    selectedCharacter: null,

    // States related with segmentation process.
    segmentationOrder: {
      process         : null,
      uuid            : null,
      locationVerified: false,
      hasCollaborators: false,
      segmentations   : {}
    },

    segmentationQuestions: [],

    // State to keep the current editing order.
    currentEditingOrder: {
      uuid      : '',
      process   : '',
      eventtype : '',
      categories: null,
      characters: null,
      messages  : null,
      attendees : null,
      last_step : 1
    },

    // Items, that event owner select manually with count
    // they will not be available in attendee process
    manualSelectedItemsQuantity: [],

    // State representing order saving process.
    isSavingCurrentOrder: false,

    isModalActive: false,

    // caterer
    catererDetails: null,

    orderCollaboratorInvitations: [],

    // event planner
    eventPlannerDetails: null,

    // state for attendee order characters
    attendeeOrderCharacters: [],

  },
  mutations,
  actions,
  getters,
})
